__turbopack_context__.v({
  "button": "etFgsG_button" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "contentHidden": "etFgsG_contentHidden",
  "fullWidth": "etFgsG_fullWidth",
  "icon": "etFgsG_icon",
  "label": "etFgsG_label",
  "labelWrapper": "etFgsG_labelWrapper",
  "loadingIcon": "etFgsG_loadingIcon",
  "sizeM": "etFgsG_sizeM",
  "sizeS": "etFgsG_sizeS",
  "sizeXS": "etFgsG_sizeXS",
  "spin": "etFgsG_spin",
  "variantOutlinedNeutral": "etFgsG_variantOutlinedNeutral",
  "variantOutlinedPrimary": "etFgsG_variantOutlinedPrimary",
  "variantOverlayNeutral": "etFgsG_variantOverlayNeutral",
  "variantOverlayPrimary": "etFgsG_variantOverlayPrimary",
  "variantPrimary": "etFgsG_variantPrimary",
  "variantSecondary": "etFgsG_variantSecondary",
  "variantTransparentNeutral": "etFgsG_variantTransparentNeutral",
  "variantTransparentPrimary": "etFgsG_variantTransparentPrimary",
});
